import type SafeAreaProps from './types';

export default ({children}: SafeAreaProps) => children;
